// TODO https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
export const withResolvers = <T>() => {
  let resolve;
  let reject;

  const promise = new Promise<T>((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });

  return {
    promise,
    resolve: resolve as unknown as (value: T | PromiseLike<T>) => void,
    reject: reject as unknown as (reason?: unknown) => void,
  };
};
